<template lang="pug">
.company-editor-layout
  router-view
</template>

<script setup lang="ts">
  import { onMounted } from 'vue'

  import { onBeforeRouteLeave, useRoute } from 'vue-router/composables'
  import useEditor from '@/composables/useEditor'

  import { UserModule } from '@/store/modules/user'
  import { EditorModule } from '@/store/modules/editor'

  const route = useRoute()
  const { inEditorMode } = useEditor(route)

  onMounted(() => {
    if (UserModule.isCompanyEditor) {
      EditorModule.setEditMode(true)
    }
  })

  onBeforeRouteLeave((_to, _from, next) => {
    if (['CourseModule', 'Lesson'].includes(_to.name as string) && !inEditorMode.value) {
      EditorModule.setEditMode(true)
    } else {
      EditorModule.setEditMode(false)
    }
    next()
  })
</script>

<style lang="postcss" scoped></style>
